var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPgAcmeHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_477_1307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0C6.93983 0 0 6.93983 0 15.5C0 24.0602 6.93983 31 15.5 31C24.0602 31 31 24.0602 31 15.5C31 6.93983 24.0608 0 15.5 0ZM2.67936 15.5C2.67936 8.4195 8.4195 2.67936 15.5 2.67936C22.5805 2.67936 28.3206 8.4195 28.3206 15.5C28.3206 18.6122 27.2116 21.4653 25.3667 23.6855L16.181 5.43244L8.00563 21.5492C8.00563 21.5492 10.8791 18.8556 14.0758 18.5236L16.1905 14.1894L22.2985 26.2628L22.475 26.258C20.4672 27.5625 18.0725 28.3206 15.5 28.3206C8.4195 28.3206 2.67936 22.5805 2.67936 15.5Z",
    fill: "#00205B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8465 19.1356C9.8464 19.9093 7.29688 23.0688 7.29688 23.0688H12.9586C17.3218 23.0688 17.1406 19.1356 17.1406 19.1356H13.8465Z",
    fill: "#00205B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_477_1307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPgAcmeHeaderLogo);
export default __webpack_public_path__ + "static/media/pg-acme-header-logo.ccd270056e1d7f26c25940af3f38e489.svg";
export { ForwardRef as ReactComponent };